<template>
  <footer :class="{ 'inherited-footer': !inherit }">
    <div class="container">
      <div class="footer-content">
        <div class="footer-column">
          <h3>{{ $t("aboutUs") }}</h3>
          <p>
            {{
              $i18n.locale === "zh"
                ? configData.company.company_introduced
                : configData.company.company_introduced_en
            }}
          </p>
        </div>

        <div class="footer-column">
          <h3>{{ $t("contactUs") }}</h3>
          <p>{{ $t("phoneFooter") }}：{{ configData.company.company_phone }}</p>
          <p>{{ $t("email") }}：{{ configData.company.company_email }}</p>
          <p>
            {{ $t("address") }}：{{
              $i18n.locale === "zh"
                ? configData.company.company_address
                : configData.company.company_address_en
            }}
          </p>
        </div>

        <div class="footer-column">
          <h3>{{ $t("followUs") }}</h3>
          <div class="social-media">
            <el-button icon="el-icon-weibo" circle size="small"></el-button>
            <el-button icon="el-icon-wechat" circle size="small"></el-button>
            <el-button icon="el-icon-qq" circle size="small"></el-button>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>
          {{ $t("copyright") }} |
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noopener noreferrer"
            style="color: inherit; text-decoration: underline"
          >
            {{ $t("recordNo") }}
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AppFooter",
  props: {
    inherit: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState("config", ["configData"]),
  },
};
</script>

<style scoped>
footer {
  background-color: #f5f5f5;
  padding: 40px 0;
  color: #666;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.footer-column {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.footer-column h3 {
  font-size: 16px;
  margin-bottom: 15px;
  color: #333;
}

.social-media {
  display: flex;
  gap: 10px;
}

.footer-bottom {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}

.inherited-footer {
  background-color: #fff;
}

@media (max-width: 767px) {
  .footer-content {
    flex-direction: column;
  }
  .footer-column {
    min-width: auto;
  }
}
</style>
